import type { PressurePoint } from "@/types/geodata";

function project(lat: number, lng: number) {
  return {
    left: `${((lng + 180) / 360) * 100}%`,
    top: `${((90 - lat) / 180) * 100}%`,
  };
}

export function PulseShaderLayer({ points }: { points: PressurePoint[] }) {
  return (
    <div className="absolute inset-0">
      {points
        .filter((point) => point.pulse)
        .map((point) => (
          <div
            key={point.id}
            className="absolute h-5 w-5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-red-400 shadow-[0_0_28px_rgba(248,113,113,0.85)]"
            style={project(point.coordinates.lat, point.coordinates.lng)}
          >
            <span className="absolute inset-0 animate-ping rounded-full bg-red-400/70" />
          </div>
        ))}
    </div>
  );
}
